import { render } from "./promo-banner.vue?vue&type=template&id=7dfc304a"
import script from "./promo-banner.vue?vue&type=script&lang=js"
export * from "./promo-banner.vue?vue&type=script&lang=js"

import "./promo-banner.vue?vue&type=style&index=0&id=7dfc304a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__